import { Box } from '@mui/material'
import React from 'react'
import Sidebar from '../submodules/Sidebar';
import ReadingPane from '../submodules/ReadingPane';

const LearningCenter = (props) => {
  return (
    <Box sx={{display: "flex", flexWrap: "wrap",}}>
      <Box sx={{display: "flex", flex: 1, flexWrap: "wrap", flexDirection: "column", margin: 1, minWidth: 200,}}>
        <Sidebar />
      </Box>
      <Box sx={{display: "flex", flex: 4, flexWrap: "wrap", flexDirection: "column", margin: 1,}}>
        <ReadingPane />
      </Box>
    </Box>
  )
}

export default LearningCenter
